import { StylingModel } from '../style/styling.model';
export class CoreStylingModel {
/**
 * Styling model for main container of component
 */
container?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    Object.assign(this, values);
    if (this.container == null) { this.container = new StylingModel(); }
  }
}

function CoreStylingModel_tsickle_Closure_declarations() {
/**
 * Styling model for main container of component
 * @type {?}
 */
CoreStylingModel.prototype.container;
}

